<div class="alert alert-success">
  <span>Successfully saved!</span>
</div>